import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardService} from 'src/app/dashboard/dashboard.service';
import {LocalStorageService} from 'src/app/local-storage.service';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  authKey = '';
  token: any;
  user: any = {};

  constructor(private storageService: LocalStorageService,
              private dashboardService: DashboardService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit(): void {
    this.token = window.localStorage.getItem(environment.authKey);
    this.getCurrentUserData();
  }

  getCurrentUserData(): void {
    this.dashboardService.getCurrentUserData().subscribe((data) => {
      if (!data) { this.logout(); }
      this.user = data;
    }, (err) => {
      this.logout();
    });
  }

  logout(): void {
    this.storageService.logout();
    this.router.navigateByUrl('/login');
  }
}
